import React from 'react'
import { Grid, Tooltip } from '@mui/material'
import { LARGE_RADIUS, MAIN_RADIUS } from '../../../../utils/constants/Theme'
import PropTypes from 'prop-types'

const MARGE = '0.5rem'
const FONT_SIZE = '1rem'
const CardMapCms = ({
    cms,
    isMap,
    categ,
    detailed,
    onHover,
    setIsOpen,
}) => {
    const {
        color,
        markerName,
        cardMarkerIcon,
        markerIcon,
        typeName,
    } = cms
    const imgSize = isMap ? { width: `calc(50% + ${MARGE})` } : { height: cardMarkerIcon ? '30px' : '40px' }
    const cardIcon = cardMarkerIcon || markerIcon
    const isContact = ['contact', 'contributor'].includes(typeName)

    return (
        <Grid
            container
            size={12}
            sx={{
                cursor: 'pointer',
                border: `solid 3px ${color || 'black'}`,
                borderRadius: isMap ? LARGE_RADIUS : MAIN_RADIUS,
                overflow: 'hidden',
                fontSize: FONT_SIZE,
                backgroundColor: color || 'white',
                width: '100%',
            }}
            onClick={() => {
                setIsOpen(true)
            }}
            onMouseOver={() => onHover(cms, true)}
            onMouseOut={() => onHover(cms, false)}
        >
            <Grid
                container size={12}
                alignItems='center'
            >
                <Grid container size={isMap ? 2 : 1} alignItems='center' sx={{ height: '100%' }}>
                    <Grid size={12} sx={{ '& img': imgSize, textAlign: 'center', padding: MARGE }}>
                        <Tooltip title={markerName} placement='top'>
                            {cardIcon.startsWith('<svg') ? (
                                <img src={`data:image/svg+xml;utf8,${cardIcon}`} />
                            ) : (
                                <img src={cardIcon} />
                            )}
                        </Tooltip>
                    </Grid>
                </Grid>
                <Grid container size={isMap ? 10 : 11} sx={{ backgroundColor: 'white', minHeight: isMap ? '67px' : '50px' }}>
                    <Grid container size={12} sx={{ padding: MARGE }}>
                        {!!cms && (
                            <Grid size={12} sx={{ fontWeight: 'bold' }}>
                                {cms.title}
                            </Grid>
                        )}
                        <Grid
                            container
                            direction={'row'}
                            size={12}
                            sx={{ paddingBottom: isContact && detailed ? MARGE : 0 }}
                        >
                            Auteur : <span style={{ fontWeight: 'bold' }}> {cms.author} </span>
                        </Grid>
                        <Grid
                            container
                            direction={'row'}
                            size={12}
                            sx={{ paddingBottom: isContact && detailed ? MARGE : 0 }}
                        >
                            Catégorie : <span style={{ fontWeight: 'bold' }}> {categ.title} </span>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}
CardMapCms.propTypes = {
    cms: PropTypes.shape({
        id: PropTypes.number,
        title: PropTypes.string,
        author: PropTypes.author,
        cardMarkerIcon: PropTypes.string,
        markerIcon: PropTypes.string,
        markerName: PropTypes.string,
        icon: PropTypes.string,
        typeName: PropTypes.string,
        color: PropTypes.string,
    }),
    isMap: PropTypes.bool,
    categ: PropTypes.string,
    detailed: PropTypes.bool,
    onHover: PropTypes.func,
    setIsOpen: PropTypes.func,
}
export default CardMapCms
